import { AppDate } from './date.model';
import { Attribute } from './attribute.model';

import { each } from 'lodash-es';
import { find } from 'lodash-es';

export class BaseModel {

    public attrs: Array<Attribute> = [];

    constructor(data, conversions = {}, attrProperties = []) {
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }

        const propKeys = Object.keys(conversions);
        propKeys.forEach( key => {
           const props = conversions[key];

            switch (key) {
                case 'num':

                    props.forEach( ( prop: string) => {
                        if (data && data[prop]) { data[prop] = Number(data[prop]); }
                    });
                    break;
                case 'bool':
                    props.forEach( (prop: string) => {
                        if (data && data[prop]) {
                            if (isNaN(data[prop])) {
                                data[prop] = (data[prop] === 'true');
                            } else {
                                data[prop] = Boolean(Number(data[prop]));
                            }
                        }
                    });
                    break;
                case 'date':
                    props.forEach( (prop: string) => {
                        if (data && data[prop]) { data[prop] = new AppDate(data[prop]); }
                    });
                    break;
            }

        });


        // Defined on the prototype, not on the instance. lodash cloneDeep - which the order and
        // list flows use heavily - copies own ENUMERABLE properties onto a fresh object of the same
        // prototype, so an instance-level accessor was silently dropped by every clone while attrs
        // itself survived: the cloned model still carried the data but could no longer read it.
        // A prototype accessor survives the clone and stays out of Object.keys(), so request
        // payloads built by spreading a model are unchanged.
        const proto = Object.getPrototypeOf(this);
        each(attrProperties, (prop) => {
            const key = 'attr_' + prop;
            if (Object.prototype.hasOwnProperty.call(proto, key)) {
                return;
            }

            Object.defineProperty(proto, key, {

                // the accessor now outlives the instance that declared it, so it stays replaceable -
                // a property fixed onto a shared prototype for the life of the page is not
                configurable: true,

                get: function () {
                    if (this.hasAttr(prop)) {
                      return this.getAttrValue(prop);
                    }

                    return null;
                },
                set: function (value) {
                    this.setAttrValue(prop, value);
                }
            });
        });

        if (data && data['attrs']) {
            const attrs = [];

            each(data['attrs'], attr => {
                attrs.push(new Attribute(attr));
            });

            data['attrs'] = attrs;
        }

        if (data) { Object.assign(this, data); }
    }

    public hasAttr(key): boolean {
        return (find(this.attrs, {attr: key}) != undefined)
    }

    public getAttr(key): Attribute {
        return this.attrs.find( attr => attr.attr === key);
    }

    public getAttrValue(key): string {
        const attr: Attribute = this.getAttr(key);

        return (attr) ? attr.value : null;
    }

    public setAttrValue(key: string, value: string | number) {
        const attr: Attribute = this.getAttr(key);

        if (attr) {
            attr.value = value as string;
        } else {
            this.attrs.push(new Attribute({attr: key, value: value}));
        }
    }
}
